import clsx from "clsx";
import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import styles from "./styles";

const InfoCard = ({uid, isNewDesign, info_text, classes}) => {

  return (
    <div className={clsx(classes.stepInfoText, isNewDesign && 'newDesign')} data-id={`${uid}-info`}>
      <span className='far fa-info-circle' />
      {!isNewDesign && <>&nbsp;</>}
      {info_text}
    </div>
  )
};

export default withStyles(styles)(InfoCard);